import { Component, Input } from '@angular/core';

import { MensagemService } from '@app/shared/services/mensagem.service';
import { CensoService } from '@app/shared/services/censo.service';

import { environment } from '@environments/environment';

import { Censo } from '@app/shared/models';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  @Input() header: any;
  @Input() headerMobile: any;

  cliente = environment.cliente;
  censo: Censo;

  constructor(
    private censoService: CensoService,
    private mensagemService: MensagemService
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
  }

  redirecionar(): void {
    return this.mensagemService.avisoMensagemAlerta(
      'Teremos uma interrupção temporária do nosso servidor com o objetivo de melhorar nossa estrutura. Agradecemos a compreensão de todos.',
      'AVISO DE MANUTENÇÃO'
    )
  }
}
